import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import Root from './containers/routes/Root';
import SimpleReactLightbox from 'simple-react-lightbox';

import { store, persistor } from './store';
import 'translation';
ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
      <Root store={store} persistor={persistor} />
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
